<!-- `←`/`→` moram no botão (o elemento focável), não no grupo: o foco está sempre na fase marcada (tabindex rotativo). -->
<div class="mg-mapa" role="radiogroup" aria-label="Fases da jornada">
  @for (fase of FASES; track fase.numero) {
    <button
      type="button"
      role="radio"
      class="mg-mapa__fase"
      (keydown.arrowleft)="mover(-1)"
      (keydown.arrowright)="mover(1)"
      [class.mg-mapa__fase--concluida]="resposta(fase.numero)?.concluida"
      [class.mg-mapa__fase--atual]="fase.numero === faseAtual"
      [class.mg-mapa__fase--selecionada]="fase.numero === selecionada"
      [attr.aria-checked]="fase.numero === selecionada"
      [attr.tabindex]="fase.numero === selecionada ? 0 : -1"
      (click)="selecionar.emit(fase.numero)"
    >
      <span class="mg-mapa__numero" aria-hidden="true">
        @if (resposta(fase.numero)?.concluida) {
          <mat-icon svgIcon="check_circle" class="mg-icone mg-icone--p"></mat-icon>
        } @else {
          {{ fase.numero }}
        }
      </span>
      <span class="mg-mapa__nome">{{ fase.nome }}</span>
      <span class="mg-mapa__legenda">{{ legenda(fase.numero) }}</span>
    </button>
  }
</div>
